export default "__VITE_ASSET__CZ_SLriL__"